import { createContext } from "react";

const DeductionContext = createContext();

export default DeductionContext;
